export interface SignalMessage {
  type: string;
  [k: string]: unknown;
}

export class SignalingClient {
  private ws: WebSocket;
  private handlers: ((m: SignalMessage) => void)[] = [];
  ready: Promise<void>;
  closed: Promise<void>;

  constructor(url: string) {
    this.ws = new WebSocket(url);
    this.ready = new Promise<void>((resolve, reject) => {
      this.ws.addEventListener("open", () => resolve(), { once: true });
      this.ws.addEventListener("error", () => reject(new Error("signaling error")), { once: true });
    });
    this.closed = new Promise<void>((resolve) => {
      this.ws.addEventListener("close", () => resolve(), { once: true });
    });
    this.ws.addEventListener("message", (e) => {
      if (typeof e.data !== "string") return;
      let parsed: SignalMessage;
      try { parsed = JSON.parse(e.data); } catch { return; }
      for (const h of this.handlers) h(parsed);
    });
  }

  onMessage(h: (m: SignalMessage) => void): void {
    this.handlers.push(h);
  }

  send(m: SignalMessage): void {
    if (this.ws.readyState === WebSocket.OPEN) {
      this.ws.send(JSON.stringify(m));
    }
  }

  close(): void {
    try { this.ws.close(); } catch { /* */ }
  }
}
